import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import GroupsIcon from '@mui/icons-material/Groups';
import WcIcon from '@mui/icons-material/Wc';
import ToggleButton from '@mui/material/ToggleButton';
import Switch from '@mui/material/Switch'
import Zoom from '@mui/material/Zoom';
import Fade from '@mui/material/Fade';
import HeightInfoDrawer from "../info_components/HeightInfo"

const CustomHeightSlider = styled(Slider)(({ theme, activegender }) => ({
  height: 8,
  // width: "90%",
  // display: "block",

  // position: "abosolute",
  margin: "auto",
  // padding: '0px 10px 0 10px',
  // margin: "0 0px 20px 0px",
'&.MuiSlider-root': {
      pointerEvents: 'none !important',  // Disable clicks on the rail
    },
  '& .MuiSlider-thumb': {
    height: 28,
    width: 28,
    // boxShadow: '0 2px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)',
            backgroundColor: "white",
    border: "2.5px solid #1976d2", // MUI primary blue
    pointerEvents: 'all !important'

    // backgroundColor: '#212121',
    // '&:hover': {
    //   boxShadow: '0 0 0 10px rgba(58, 133, 137, 0.16)',
    // },
    // '&:before': {
    //   boxShadow:
    //     '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
    // },
  },
  // '& .MuiSlider-thumb[data-index="0"]': {
  //   backgroundImage: "radial-gradient(circle, #000000 40%, #abebff)"
  // },
  // '& .MuiSlider-thumb[data-index="1"]': {
  //   backgroundImage: "radial-gradient(circle, #000000 40%, #abebff)"
  // },
  '& .MuiSlider-valueLabel': {
    fontSize: 14,
    fontWeight: 'normal',
    top: -5,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    // '&::before': {
    //   display: 'none',
    // },
    // '& *': {
    //   background: 'transparent',
    //   color: '#000',
    //   ...theme.applyStyles('dark', {
    //     color: '#fff',
    //   }),
    // },
  },
  '& .MuiSlider-markLabel[data-index="0"]': {
    top: "15px",
    // margin: "0 -28px",
    // margin: "0 -15px",
    fontSize: 12
  },
  '& .MuiSlider-markLabel[data-index="1"]': {
    top: "15px",
    // margin: "0 0 0 28px",
    // margin: "0 0 0 15px",
    fontSize: 12
  },
  '& .MuiSlider-track': {
    border: 'none',
    // backgroundColor: '#1976D1',
    backgroundImage: "linear-gradient(.25turn, #8ED4FF, #008FF5)",
    height: 10,
    // margin: "0 20px 0 20px"

  },
  '& .MuiSlider-rail': {
    // opacity: 0.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#29292D',
    height: 10,
    // padding: "0 10px 0 10px"
  },
  '& .MuiTabPanel-root': {
    padding: 0,
    // margin: "0 20px 0 20px"

  },
  // ...theme.applyStyles('dark', {
  //   color: '#0a84ff',
  // }),
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#008ff5',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#abebff',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));

export default function Height({ height, onSlide, activeGender, activeImperial, onImperialToggle, activeHeightRange, heightPercent }) {

  let cmFtFormatter = (num) => {
    return activeImperial ? (`${Math.floor(num / 12)}'${num % 12}"`) : (num + "cm")
  }

  let cmFtFormatterMinMax = (num) => {
    return activeImperial ? (`${Math.floor(num / 12)}'${num % 12}"`) : (num)
  }

  const value = height.slice()
  const minMaxValues = activeHeightRange.slice()

  const minDistance = activeImperial ? 1 : 5;

  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  const isIOS = iOS();


  const marks = [
    {
      value: minMaxValues[0],
      label: activeImperial ? "<" + cmFtFormatterMinMax((minMaxValues[0])) : "<" + minMaxValues[0],
    },
    {
      value: minMaxValues[1],
      label: activeImperial ? cmFtFormatterMinMax((minMaxValues[1])) + "+" : minMaxValues[1] + "+",
    },
  ];




  const handleChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (isIOS && event.type === "mousedown") {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 200 - minDistance);
        onSlide([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        onSlide([clamped - minDistance, clamped]);
      }
    } else {
      onSlide(newValue);
    }
  };


  let minMaxFormatter = (num) => {
    if (num === minMaxValues[1]) { return cmFtFormatter(num) + "+" }
    else if (num === minMaxValues[0]) { return "<" + cmFtFormatter(num) }
    else { return cmFtFormatter(num) }
  }


  const [selectedInfo, setSelectedInfo] = useState(false);
  const [selectedHelp, setSelectedHelp] = useState(false);

  const [valueChange, setValueChange] = useState(false);
  const [heightTip, setHeightTip] = useState(false);
    
    useEffect(() => {
      if(valueChange) {
      setTimeout(() => {
        setHeightTip(true)
    }, 1500);
  }
    
  }, [valueChange]);


  useEffect(() => {
    if((100-heightPercent) > 50){setValueChange(true)}
    else(setValueChange(false))
}, [heightPercent]);
  
  


  return (
    <div className="wrapperScroll">

      <div className="wrapperWidth">
        <div className="sliderContainerParent">
<Fade
                        // in={false ? true : false}
                        in={selectedHelp ? true : false}
                        timeout={500}
                    >
                        <div className="helpContainer" onClick={() => { setSelectedHelp(!selectedHelp) }}>
                            <div className="helpBox">
                                <h2 className="helpText">Tips</h2>
                                <p className="helpText">- 📏 The min and max heights reflect the bottom and top 5th percentiles. For example, the max selectable height for men (6’3”+) represents the tallest 5% of men.</p>
                                <p className="helpText">- 🚻 Selected Gender will affect selectable height values—for instance, the max selectable height if [Women] is chosen is 5’9”. Meanwhile, for [Men], the max is 6’3”.</p>
                                <p className="helpText">- 🌻 Selected Race will also affect selectable height values. For example, the max selectable height (the top 5th percentile) when only Asian women are chosen is 5’7”, where it is 5’9” when Black, White, or “Open to All Races” is chosen.</p>
                            </div>
                        </div>
                    </Fade>
                    <HeightInfoDrawer selectedInfo={selectedInfo} setSelectedInfo={setSelectedInfo} isMetric={!activeImperial} />
          <div className="componentHeaderContainer">
            <div className="componentHeader">
              <div className="descriptionContainer">
                <p className="description">Desired height range</p>
              </div>
              <div className="info">
                  <Tooltip
                    title={ <>
                      <p className="correlatedText">Selected gender influences</p>
                      <p className="correlatedText">selectable height values</p>
                    </>}
                    placement="top"
                    arrow
                    enterTouchDelay={0}
                    enterDelay={200}
                    leaveTouchDelay={4000}
                    slots={{
                      transition: Zoom,
                    }}
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10],
                            },
                          },
                        ],
                      },
                    }}
                  >
                    <WcIcon fontSize="small" className="correlatedIcon" />
                  </Tooltip>
                <Tooltip
                    title={ <>
                      <p className="correlatedText">Selected races influence</p>
                      <p className="correlatedText">selectable height values</p>
                    </>}
                    placement="top"
                    arrow
                    enterTouchDelay={0}
                    enterDelay={200}
                    leaveTouchDelay={4000}
                    slots={{
                      transition: Zoom,
                    }}
                    slotProps={{
                      popper: {
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -10],
                            },
                          },
                        ],
                      },
                    }}
                  >
                                      <GroupsIcon fontSize="small" className="correlatedIcon" />

                  </Tooltip>
                {/* </div> */}
                <ToggleButton
                  value={1}
                  selected={selectedInfo}
                  onChange={() => setSelectedInfo((prevSelected) => !prevSelected)}
                  sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgb(45 185 255 / 17%)" } }}
                >
                  <InfoIcon />
                </ToggleButton>
                <ToggleButton
                                    value={1}
                                    selected={selectedHelp}
                                    onChange={() => {setSelectedHelp((prevSelected) => !prevSelected); setSelectedInfo(false)}}
                                    sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                                >
                                    <HelpIcon />
                                </ToggleButton>
              </div>

            </div>

            {/* <p className="note">Min and max points represent all other height values in the bottom and top 5th percentiles</p> */}

            <div className="switchContainer">
              <p className="switchText">cm</p>
              <AntSwitch
                checked={activeImperial}
                value={activeImperial}
                onChange={onImperialToggle}
              // inputProps={{ 'aria-label': 'ant design' }} 
              />
              <p className="switchText">ft</p>
            </div>
            {/* <p>{value + height}</p> */}
            {/* <p>{minMaxValues + activeHeightRange}</p> */}

          </div>
          <div className="ageContainer">
            <Box sx={{ width: "100%", margin: "12px 0 0 0", padding: "12px 0 0 0" }}>
              <CustomHeightSlider
                value={value}
                min={minMaxValues[0]}
                max={minMaxValues[1]}
                // marks={marks}
                onChange={handleChange}
                valueLabelDisplay="on"
                disableSwap
                activegender={activeGender}
                // valueLabelFormat={value => value + measurement}
                valueLabelFormat={value => minMaxFormatter((value))}
              />
            </Box>
          </div>
          <div>
            <p className="source">Source: CDC, 2021 National Health and Nutrition Examination Survey</p>
          </div>
        </div>
      </div>


      <div className="catContainerCriteria">
        <div className="img-wrapper"
          style={heightTip ? { display: "block", animationName: "upCat" } : { display: "none" }}
        >
                {/* <div id="calico" className="bye-container"> */}
          {/* <div className="questionContainer"> */}
          <Fade
      in={heightTip}
      {...(heightTip ? { timeout: 2000 } : {})}
      >
        {/* <> */}
            <div id="calico" className="question-bubble" 
            >
              <div>
            {valueChange ?  <p><strong>Uh Oh!</strong></p> : <p><strong>Okay</strong></p>}
            </div>
            {valueChange ? 
              <p >Your selected height range <span className="highlight">excludes {100-heightPercent}%</span> of the population!
              </p>
              : <p>Your selected height range now just <span className="highlight">excludes {100-heightPercent}%</span> of the population.
              </p>
            }
          </div>
          </Fade>

          <img src={"../images/siamese.png"} className="catImgCriteria"></img>

        </div>
      </div>
    </div>
  );
}
